const PRISMIC_TOKEN = 'MC5YcXNIM2hFQUFDVUFoNTh3.LAM9Oe-_ve-_ve-_vXjvv73vv73vv73vv73vv71eai9a77-9Bu-_ve-_ve-_vRLvv73vv71gDu-_ve-_ve-_ve-_ve-_vQ';

module.exports = {
  PRISMIC_TOKEN,
};
